import {LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import "@/components/form/form.scss"
import {query} from "lit/decorators/query.js";
import "@/components/job-listing/job-listing.scss"
import {SbkPagination} from "@/components/pagination/pagination";
import {SbkForm} from "@/components/form/form.ts";

@customElement('sbk-job-listing')
export class SbkJobListing extends LitElement {

    @query('form')
    _form!: HTMLFormElement

    @query('sbk-pagination')
    _pagination!: SbkPagination

    @query('.job-results')
    _resultContainer!: HTMLDivElement

    @query('.job-results__heading')
    _resultHeading: HTMLElement | undefined

    connectedCallback() {
        super.connectedCallback();
        this._form.addEventListener('submit', (e) => {
            e.preventDefault()
            this._onSubmit();
        });
        this._pagination && this._pagination.addEventListener('page-change', (e) => {
            e.preventDefault()
            const href = (<CustomEvent> e).detail.value;
            this._handlePageChange(href);
        });
    }

    protected createRenderRoot() {
        return this
    }

    private _onSubmit() {
        const invalidElements = SbkForm.validate(this._form);
        if (invalidElements.length) {
            const firstInvalidElement = invalidElements[0];
            firstInvalidElement.focus({preventScroll: true});
            firstInvalidElement.scrollIntoView({behavior: 'smooth'});
        } else {
            fetch(this._form.action, {
                method: this._form.method,
                body: new FormData(this._form),
            })
                .then((response) => {
                    return response.text()
                })
                .then((data) => {
                    this._replace(data)
                })
        }
    }

    private _handlePageChange(href: string) {
        fetch(href, {})
            .then((response) => {
                return response.text()
            })
            .then((data) => {
                this._replace(data)
            })
    }

    private _replace(data: string) {
        if (this._resultHeading) {
            this._resultHeading.focus({preventScroll: true});
            this._resultHeading.scrollIntoView({
                behavior: 'smooth'
            })
        }
        this.outerHTML = data
    }
}
